import React from "react";
import {
  AiFillPhone,
  AiFillMail,
  AiFillHome,
  AiOutlineGlobal,
} from "react-icons/ai";
import { BiSolidChevronRight } from "react-icons/bi";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <section
        className="bg-cover bg-center relative text-white px-6 py-16 md:px-20"
        style={{
          backgroundImage: 'url("./img/service/cal1.jpeg")',
        }}
      >
        {/* Darker Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-80"></div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center space-y-12 md:space-y-0">
          {/* Left Text */}
          <div className="max-w-md">
            <h2 className="text-4xl font-bold leading-snug text-white">
              Get in{" "}
              <span className="bg-orange-600 px-2 rounded text-white">
                touch
              </span>
            </h2>
            <p className="mt-4 text-md text-orange-600">
              Let’s build a partnership that leads to incredible results —
              together.
            </p>
          </div>

          {/* Call Section */}
          <div className="flex items-start space-x-4 p-5 rounded-lg shadow-md hover:shadow-lg transition">
            <FaPhoneAlt className="text-white text-3xl mt-1" />
            <div>
              <p className="text-white/90 font-semibold text-2xl">Call us</p>
              <p className="text-sm text-orange-600 mt-1">+91- 74000 91415</p>
            </div>
          </div>

          {/* Email Section */}
          <div className="flex items-start space-x-4 p-5 rounded-lg shadow-md hover:shadow-lg transition">
            <MdEmail className="text-white text-3xl mt-1" />
            <div>
              <p className="text-white/90 font-semibold text-2xl">Email us</p>
              <p className="text-sm text-orange-600 mt-1">
                stratusinst@gmail.com
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer
        // className="bg-slate-900 text-black pt-12 pb-6"
        className="bg-cover pt-12 pb-6"
        style={{
          backgroundImage: 'url("./img/footerImage.jpg")',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8 lg:justify-items-end">
            {/* Logo & Description */}
            <div>
              <div className="flex items-center space-x-2">
                <img
                  src="./img/service/rectlogo.png"
                  alt="Logo"
                  className="h-[100px] w-30 mb-4"
                />
              </div>
              <p className="text-sm font-medium">
                We serve nationally and internationally. We believe in{" "}
                <span className="text-orange-500">
                  “Service quality at best prices”.
                </span>
                <p className="text-orange-500 mt-5">
                  <span className="text-black font-medium">CIN :</span>{" "}
                  U52609MH2018PTC312048
                  <br />
                  <span className="text-black font-medium mt-5">
                    GSTIN :
                  </span>{" "}
                  ABACS6003M1ZA
                </p>
              </p>
              {/* <p className="text-black font-medium text-sm leading-relaxed">
              STRATUS INSTRUMENTATION PVT. LTD. has been a long-term trusted partner for
              clients in the Navi Mumbai & all over National International
              region; working closely with our clients allows us to act in their
              best interest over the long term.
            </p> */}
            </div>

            {/* Company Group */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-orange-600">
                Our Location
              </h3>
              <ul className="text-sm text-black font-medium space-y-2 mt-6">
                <li className="flex items-start gap-2">
                  <AiFillHome className="text-orange-600 mt-1" />
                  <span>
                    Siddhivinayak Residency,
                    <br />
                    Shop No-05 to 08, Sector-09,Plot No-40,
                    <br />
                    Kamothe, Navi Mumbai-410209 MH
                  </span>
                </li>
                <li className="flex items-center gap-2">
                  <AiFillMail className="text-orange-600" />
                  <span>stratusinst@gmail.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <AiFillPhone className="text-orange-600" />
                  <span>+91- 74000 91415</span>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-orange-600">
                Our Services
              </h3>
              <ul className="space-y-2 text-sm">
                {[
                  { label: "Mapping Services", path: "/service1" },
                  { label: "Calibration", path: "/calibrationInstruments" },
                  { label: "HVAC Validation", path: "/hvacservice" },
                  { label: " Other Services", path: "/otherservice" },
                ].map(({ label, path }) => (
                  <li key={label} className="w-[200px] flex items-center">
                    <BiSolidChevronRight className="text-[20px] font-bold text-[#FF6600]" />
                    <Link
                      to={path}
                      className=" hover:text-orange-600 hover:tracking-wider	 ease-in duration-500 text-black font-medium"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-4 text-orange-600">
                Quick Links
              </h3>
              <ul className="space-y-2 text-sm">
                {[
                  { label: "Home", path: "/" },
                  { label: "About Us", path: "/about" },
                  { label: "Service", path: "/" },
                  { label: "Client", path: "/client" },
                  { label: "Contact", path: "/contact" },
                ].map(({ label, path }) => (
                  <li key={label} className="w-[200px] flex items-center">
                    <BiSolidChevronRight className="text-[20px] font-bold text-[#FF6600]" />
                    <Link
                      to={path}
                      className=" hover:text-orange-600 hover:tracking-wider	 ease-in duration-500 text-black font-medium"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom Line */}
          {/* <div className="border-t border-gray-700 pt-6 text-sm text-black font-medium flex flex-col md:flex-row justify-between items-center gap-4"> */}
          <div className="border-t border-gray-700 pt-6 text-sm text-black font-medium text-center">
            <p>© 2025 STRATUS INSTRUMENTATION PVT. LTD.</p>
            {/* <p className="text-center md:text-right">
            We serve nationally and internationally. We believe in{" "}
            <span className="text-orange-500">
              “Service quality at best prices”.
            </span>
          </p> */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
